import { identity as parse } from 'lodash';
import React from 'react';
import { useField } from 'react-final-form';

import CTAButton from '../../../CTAButton/CTAButton';
import type { BonusTab } from '../../BonusOffer';

import { TXTWCL_Continue_without_bonus } from './SkipBonusCode.messages.json';

interface Props {
  setSelectedTab(tab: BonusTab): void;
}

const SkipBonusCode: React.FC<Props> = ({ setSelectedTab }) => {
  const {
    input: { onChange }
  } = useField('deposit.bonusCode', { subscription: { value: true }, parse });

  return (
    <CTAButton
      variant="secondary"
      type="submit"
      onClick={() => {
        setSelectedTab('');
        onChange('');
      }}
      translation={TXTWCL_Continue_without_bonus}
    />
  );
};

export default SkipBonusCode;
